import { BaseAction } from "./BaseAction";
export class ModalAction extends BaseAction {
    execute() {
        this.renderTemplate();
        return true;
    }
}
